import React from "react"
import { Box } from "@carrotfertility/carotene-core"
import illoUnderwaterDesktopSrc from "./assets/images/illo-underwater-desktop.png"
import illoUnderwaterDesktop2xSrc from "./assets/images/illo-underwater-desktop-2x.png"
import illoUnderwaterPlantsSrc from "./assets/images/illo-underwater-plants.png"
import illoUnderwaterPlants2xSrc from "./assets/images/illo-underwater-plants-2x.png"
import illoCarrotCardsSrc from "./assets/images/illo-carrot-cards.png"
import illoCarrotCards2xSrc from "./assets/images/illo-carrot-cards-2x.png"
import illoDocAndCoinsSrc from "./assets/images/illo-doc-and-coins.png"
import illoDocAndCoins2xSrc from "./assets/images/illo-doc-and-coins-2x.png"
import illoPercentCircleSrc from "./assets/images/illo-percent-circle.png"
import illoPercentCircle2xSrc from "./assets/images/illo-percent-circle-2x.png"
import illoBlocksSrc from "./assets/images/illo-blocks.png"
import illoBlocks2xSrc from "./assets/images/illo-blocks-2x.png"
import illoCoinsAndBillsSrc from "./assets/images/illo-coins-and-bills.png"
import illoCoinsAndBills2xSrc from "./assets/images/illo-coins-and-bills-2x.png"
import illoCalendarSrc from "./assets/images/illo-calendar.png"
import illoCalendar2xSrc from "./assets/images/illo-calendar-2x.png"

// @ts-expect-error TS(7031) FIXME: Binding element 'className' implicitly has an 'any... Remove this comment to see the full error message
const IlloUnderwaterDesktop = ({ className }) => (
  <img
    className={className}
    src={illoUnderwaterDesktopSrc}
    srcSet={`${illoUnderwaterDesktop2xSrc} 2x`}
    alt=""
    width={265}
    height={230}
  />
)

const IlloCircleCarrotCards = () => (
  <Box alt="" component="img" height={228} width={228} src={illoCarrotCardsSrc} srcSet={`${illoCarrotCards2xSrc} 2x`} />
)

const IlloUnderwaterPlants = ({ height = 130, width = 212 }) => (
  <img src={illoUnderwaterPlantsSrc} srcSet={`${illoUnderwaterPlants2xSrc} 2x`} alt="" width={width} height={height} />
)

const IlloCarrotCards = () => (
  <img src={illoCarrotCardsSrc} srcSet={`${illoCarrotCards2xSrc} 2x`} alt="" width={192} height={192} />
)

const IlloDocAndCoins = ({ className = null }) => (
  <img
    className={className}
    src={illoDocAndCoinsSrc}
    srcSet={`${illoDocAndCoins2xSrc} 2x`}
    alt=""
    height={228}
    width={228}
  />
)

const IlloPercentCircle = ({ height = 228 }) => (
  <img src={illoPercentCircleSrc} srcSet={`${illoPercentCircle2xSrc} 2x`} alt="" height={height} width={height} />
)

const IlloBlocks = () => <img src={illoBlocksSrc} srcSet={`${illoBlocks2xSrc} 2x`} alt="" height={228} width={228} />

const IlloCoinsAndBills = () => (
  <img src={illoCoinsAndBillsSrc} srcSet={`${illoCoinsAndBills2xSrc} 2x`} alt="" height={228} width={228} />
)

const IlloCalendar = ({ height = 88, width = 88 }) => (
  <img src={illoCalendarSrc} srcSet={`${illoCalendar2xSrc} 2x`} alt="" height={height} width={width} />
)

export {
  IlloCircleCarrotCards,
  IlloUnderwaterPlants,
  IlloCarrotCards,
  IlloDocAndCoins,
  IlloPercentCircle,
  IlloBlocks,
  IlloCoinsAndBills,
  IlloCalendar,
  IlloUnderwaterDesktop
}
